module.exports = __webpack_public_path__ + "static/media/warning.9b8926f4.svg";